import {BlockItemDrawProps} from "../FrameBlockItem";
import {ClickableFace} from "./ClickableFace";
import {LinearDimension} from "../LinearDimension";
import {lineBlueHeavy} from "../../../const";

// VoidFace is a step in the frame outline: space outside the frame (wall, block or
// wood). Nothing is drawn on it, but it stays clickable so it can be selected, and
// while selected (or with "Show All Dimensions" on) it shows the step size from the
// outer frame line to the step stick.
export class VoidFace extends ClickableFace {
    private dims: {step: LinearDimension | null};

    constructor() {
        const dims: {step: LinearDimension | null} = {step: null};
        super((props: BlockItemDrawProps) => {
            const g = props.graphics;
            g.clear();

            const left = Math.min(props.startX, props.endX);
            const right = Math.max(props.startX, props.endX);
            const top = Math.min(props.startY, props.endY);
            const bottom = Math.max(props.startY, props.endY);

            const w = right - left;
            const h = bottom - top;
            if (w <= 0 || h <= 0) return;

            // a near-transparent fill, so the empty space still takes a click.
            g.beginFill(lineBlueHeavy, 0.001);
            g.drawRect(left, top, w, h);
            g.endFill();

            if(!dims.step) dims.step = new LinearDimension(props.dimensionContainer, props.elev.draw);
            const dim = dims.step;

            const vs = props.elev.viewSettings;
            const show = (vs.isSelected(props.block.id) || vs.dimShowAll.value) && !vs.externalDimensions.value;
            if(!show) {
                dim.hide();
                return;
            }

            const vertical = props.flowAxis === "vertical";
            const extent = vertical ? h : w;
            const extension = extent - props.size.get();

            dim.draw({
                axis: vertical ? "vertical" : "horizontal",
                from: vertical ? top : left,
                to: vertical ? bottom : right,
                cross: vertical ? (left + right) / 2 : (top + bottom) / 2,
                value: extent,
                modified: true,
                onSet: v => {
                    props.size.userSet(Math.max(0, v - extension), {debug: "step-height-edit"});
                    props.relayout();
                },
                // a step is always a set size: there is nothing to unlock it to.
                onClear: () => {},
            });
        });
        this.dims = dims;
    }

    destroy() {
        this.dims.step?.destroy();
        this.dims.step = null;
        super.destroy();
    }
}
